import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import Table from "./Table";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

const BootstrapDialogTitle = (props: DialogTitleProps) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

export default function CustomizedDialogs(props: any) {
  const {
    openTableDialog,
    handleExecuteDelete,
    handleDialogClose,
    allocatedMsisdn,
  } = props;

  return (
    <div>
      <BootstrapDialog
        onClose={handleDialogClose}
        aria-labelledby="customized-dialog-title"
        open={openTableDialog}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleDialogClose}
        >
          MSISDNs Below are Already Allocated
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Table allocatedMsisdn={allocatedMsisdn} />

          <Typography
            variant="caption"
            display="block"
            style={{
              marginTop: "5px",
              marginLeft: "3px",
              fontSize: "12px",
            }}
            gutterBottom
          >
            * Allocated MSISDNs cannot be deleted, however you can delete the
            unallocated MSISDNs. Please select only the unallocated MSISDNs.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleDialogClose}>
            Close
          </Button>
          {/* <Button autoFocus onClick={handleExecuteDelete}>
            Proceed
          </Button> */}
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}
